'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherSearch, FeatherX } from '@subframe/core';
import { Button, Select, Switch, TextField } from '@/shared/components/ui';
import type { FaturaListFilters as FaturaListFiltersType, FaturaStatus, FaturaTipoCliente, FaturaTipoGeracao } from '../types';
interface FaturaListFiltersProps {
  filters: FaturaListFiltersType;
  onChange: (patch: Partial<FaturaListFiltersType>) => void;
  onClear: () => void;
}
const STATUS_OPTIONS: {
  value: FaturaStatus | 'TODOS';
  label: string;
}[] = [{
  value: 'TODOS',
  label: 'Todos os status'
}, {
  value: 'EMITIDA',
  label: 'Emitida'
}, {
  value: 'PAGA',
  label: 'Paga'
}, {
  value: 'VENCIDA',
  label: 'Vencida'
}, {
  value: 'CANCELADA',
  label: 'Cancelada'
}, {
  value: 'ESTORNADA',
  label: 'Estornada'
}, {
  value: 'ERRO_EMISSAO',
  label: 'Erro de emissão'
}];
const TIPO_OPTIONS: {
  value: FaturaTipoGeracao | 'TODOS';
  label: string;
}[] = [{
  value: 'TODOS',
  label: 'Todos os tipos'
}, {
  value: 'MANUAL',
  label: 'Manual'
}, {
  value: 'EM_LOTE',
  label: 'Em lote'
}, {
  value: 'AGENDADA',
  label: 'Agendada'
}];
const TIPO_CLIENTE_OPTIONS: {
  value: FaturaTipoCliente | 'TODOS';
  label: string;
}[] = [{
  value: 'TODOS',
  label: 'Todos os clientes'
}, {
  value: 'CONVENIADO',
  label: 'Conveniado'
}, {
  value: 'AVULSO',
  label: 'Avulso'
}];
const isFiltering = (filters: FaturaListFiltersType): boolean => filters.status.length > 0 || filters.tipoGeracao.length > 0 || filters.tipoCliente.length > 0 || filters.busca.trim().length > 0 || filters.vencimentoInicio !== null || filters.vencimentoFim !== null || filters.emissaoInicio !== null || filters.emissaoFim !== null || filters.somenteComErroEmissao;
export function FaturaListFilters(t0) {
  const $ = _c(60);
  const {
    filters,
    onChange,
    onClear
  } = t0;
  const activeStatus = filters.status[0] ?? "TODOS";
  const activeTipo = filters.tipoGeracao[0] ?? "TODOS";
  const activeTipoCliente = filters.tipoCliente[0] ?? "TODOS";
  let t1;
  if ($[0] !== filters) {
    t1 = isFiltering(filters);
    $[0] = filters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showClear = t1;
  let t2;
  if ($[2] !== onChange) {
    t2 = value => {
      if (value === "TODOS") {
        onChange({
          status: []
        });
      } else {
        onChange({
          status: [value as FaturaStatus]
        });
      }
    };
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleStatusChange = t2;
  let t3;
  if ($[4] !== onChange) {
    t3 = value_0 => {
      if (value_0 === "TODOS") {
        onChange({
          tipoGeracao: []
        });
      } else {
        onChange({
          tipoGeracao: [value_0 as FaturaTipoGeracao]
        });
      }
    };
    $[4] = onChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleTipoChange = t3;
  let t4;
  if ($[6] !== onChange) {
    t4 = value_1 => {
      if (value_1 === "TODOS") {
        onChange({
          tipoCliente: []
        });
      } else {
        onChange({
          tipoCliente: [value_1 as FaturaTipoCliente]
        });
      }
    };
    $[6] = onChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleTipoClienteChange = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherSearch className="absolute top-9 left-3 z-10 h-4 w-4 text-neutral-400" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onChange) {
    t6 = event => onChange({
      busca: event.target.value
    });
    $[9] = onChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== filters.busca || $[12] !== t6) {
    t7 = <div className="relative flex-1">{t5}<TextField label={"Buscar por cliente, n\xFAmero ou produto"}><TextField.Input placeholder={"Ex: Silva, FAT-2026-0001, Negocia\xE7\xE3o"} value={filters.busca} onChange={t6} className="pl-9" /></TextField></div>;
    $[11] = filters.busca;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Select.Content>{STATUS_OPTIONS.map(_temp)}</Select.Content>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== activeStatus || $[16] !== handleStatusChange) {
    t9 = <div className="w-full md:w-44"><Select label="Status" value={activeStatus} onValueChange={handleStatusChange} placeholder="Selecione">{t8}</Select></div>;
    $[15] = activeStatus;
    $[16] = handleStatusChange;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Select.Content>{TIPO_OPTIONS.map(_temp2)}</Select.Content>;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== activeTipo || $[20] !== handleTipoChange) {
    t11 = <div className="w-full md:w-44"><Select label={"Tipo de gera\xE7\xE3o"} value={activeTipo} onValueChange={handleTipoChange} placeholder="Selecione">{t10}</Select></div>;
    $[19] = activeTipo;
    $[20] = handleTipoChange;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Select.Content>{TIPO_CLIENTE_OPTIONS.map(_temp3)}</Select.Content>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== activeTipoCliente || $[24] !== handleTipoClienteChange) {
    t13 = <div className="w-full md:w-44"><Select label="Tipo de cliente" value={activeTipoCliente} onValueChange={handleTipoClienteChange} placeholder="Selecione">{t12}</Select></div>;
    $[23] = activeTipoCliente;
    $[24] = handleTipoClienteChange;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = filters.vencimentoInicio ?? "";
  let t15;
  if ($[26] !== onChange) {
    t15 = event_0 => onChange({
      vencimentoInicio: event_0.target.value || null
    });
    $[26] = onChange;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t15) {
    t16 = <div className="w-full md:w-40"><TextField label="Vence a partir de"><TextField.Input type="date" value={t14} onChange={t15} /></TextField></div>;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = filters.vencimentoFim ?? "";
  let t18;
  if ($[31] !== onChange) {
    t18 = event_1 => onChange({
      vencimentoFim: event_1.target.value || null
    });
    $[31] = onChange;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t17 || $[34] !== t18) {
    t19 = <div className="w-full md:w-40"><TextField label={"Vence at\xE9"}><TextField.Input type="date" value={t17} onChange={t18} /></TextField></div>;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t11 || $[37] !== t13 || $[38] !== t16 || $[39] !== t19 || $[40] !== t7 || $[41] !== t9) {
    t20 = <div className="flex w-full flex-col gap-3 md:flex-row md:items-end">{t7}{t9}{t11}{t13}{t16}{t19}</div>;
    $[36] = t11;
    $[37] = t13;
    $[38] = t16;
    $[39] = t19;
    $[40] = t7;
    $[41] = t9;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== onChange) {
    t21 = checked => onChange({
      somenteComErroEmissao: checked
    });
    $[43] = onChange;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== filters.somenteComErroEmissao || $[46] !== t21) {
    t22 = <Switch checked={filters.somenteComErroEmissao} onCheckedChange={t21} />;
    $[45] = filters.somenteComErroEmissao;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <span className="text-sm text-neutral-700">Mostrar apenas faturas com erro de emissão</span>;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t22) {
    t24 = <label className="flex cursor-pointer items-center gap-3">{t22}{t23}</label>;
    $[49] = t22;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== onClear || $[52] !== showClear) {
    t25 = showClear && <Button variant="neutral-tertiary" size="small" icon={<FeatherX />} onClick={() => onClear()}>Limpar filtros</Button>;
    $[51] = onClear;
    $[52] = showClear;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t24 || $[55] !== t25) {
    t26 = <div className="flex w-full items-center justify-between gap-3 border-t border-neutral-100 pt-3">{t24}{t25}</div>;
    $[54] = t24;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t20 || $[58] !== t26) {
    t27 = <div className="bg-default-background flex w-full flex-col gap-3 rounded-[16px] border border-solid border-neutral-200 p-4">{t20}{t26}</div>;
    $[57] = t20;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  return t27;
}
function _temp3(option_1) {
  return <Select.Item key={option_1.value} value={option_1.value}>{option_1.label}</Select.Item>;
}
function _temp2(option_0) {
  return <Select.Item key={option_0.value} value={option_0.value}>{option_0.label}</Select.Item>;
}
function _temp(option) {
  return <Select.Item key={option.value} value={option.value}>{option.label}</Select.Item>;
}